// 數位放大（LIVE-08）：滾輪以游標為中心放大 / 縮小（1–8 倍），放大時拖曳平移，雙擊還原。
// 座標以格子左上角為原點、CSS 像素；transform = translate(x, y) scale(s)，transform-origin 0 0。
// 平移限制在畫面內（放大後的影像邊緣不離開格子邊緣）。

export interface Zoom {
  s: number;
  x: number;
  y: number;
}

export const ZOOM_IDENTITY: Zoom = { s: 1, x: 0, y: 0 };
export const ZOOM_MAX = 8;

/** 把平移夾在 [w·(1−s), 0] × [h·(1−s), 0]。 */
export function clampZoom(z: Zoom, w: number, h: number): Zoom {
  const s = Math.min(ZOOM_MAX, Math.max(1, z.s));
  if (s === 1) return ZOOM_IDENTITY;
  const x = Math.min(0, Math.max(w * (1 - s), z.x));
  const y = Math.min(0, Math.max(h * (1 - s), z.y));
  return { s, x, y };
}

/** 滾輪：deltaY < 0 放大；(px, py) 是游標在格子內的位置，放大前後游標下的那一點不動。 */
export function wheelZoom(z: Zoom, deltaY: number, px: number, py: number, w: number, h: number): Zoom {
  const factor = Math.exp(-deltaY * 0.002);
  const s = Math.min(ZOOM_MAX, Math.max(1, z.s * factor));
  const k = s / z.s;
  return clampZoom({ s, x: px - (px - z.x) * k, y: py - (py - z.y) * k }, w, h);
}

/** 拖曳平移 (dx, dy) 像素。 */
export function panZoom(z: Zoom, dx: number, dy: number, w: number, h: number): Zoom {
  if (z.s === 1) return z;
  return clampZoom({ s: z.s, x: z.x + dx, y: z.y + dy }, w, h);
}
